import { render, staticRenderFns } from "./FailGif.vue?vue&type=template&id=988c7e02&"
import script from "./FailGif.vue?vue&type=script&lang=js&"
export * from "./FailGif.vue?vue&type=script&lang=js&"
import style0 from "./FailGif.vue?vue&type=style&index=0&id=988c7e02&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports